// 照片拍摄——主流程
const MainRoutes = Array.from({ length: 14 }, (_, i) => ({
  path: `photo/index${i + 1}`,
  name: `photoIndex${i + 1}`,
  component: () => import(`@/views/travel/photo/index${i + 1}.vue`)
}))



export default {
  path: '/travel',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 照片拍摄——主流程，开始
    ...MainRoutes,

  ],
};
